import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { map, Observable, take } from 'rxjs';

import { DefaultPage } from '@shared/restaurant/enums';
import { SubscriptionState } from '@shared/recurly/enums';
import { UserAccountRole, UserLocationRole } from '@shared/user/enums';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Injectable({ providedIn: 'root' })
export class DefaultPageGuard  {
  constructor(
    private readonly router: Router,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {}

  canActivate(): Observable<UrlTree> {
    return this.authRestaurantService.select()
      .pipe(
        take(1),
        map(user => {
          if (user.location) {
            try {
              const subscriptionState = user.location.recurly?.subscription_state;
              const needsBilling = subscriptionState === SubscriptionState.paused ||
                subscriptionState === SubscriptionState.expired;
              const isAccountAdmin = user.accountUser?.role === UserAccountRole.admin;
              const isLocationManager = user.accountUser?.role === UserAccountRole.user &&
                user.locationUser?.role === UserLocationRole.manager;

              if (needsBilling && (isAccountAdmin || isLocationManager)) {
                return this.router.parseUrl('/settings/location/billing');
              }

              let navigatePath = '/waitlist';
              if (user.location.publicWaitlist.defaultPage === DefaultPage.reservation) {
                navigatePath = '/reservations';
              } else if (user.location.publicWaitlist.defaultPage === DefaultPage.floorPlan && user.account.features.floorPlan) {
                navigatePath = '/floorplan';
              }

              return this.router.parseUrl(navigatePath);
            } catch (err) {
              return this.router.parseUrl('/profile/details');
            }
          }

          return this.router.parseUrl('/profile/details');
        }),
      );
  }
}
